import $ from 'jquery'

export function setCSSVariable(name, value) {
	$(':root').css(name, value)
}

export function getCSSVariable(cssVar) {
	const root = $(':root')[0]
	return getComputedStyle(root).getPropertyValue(cssVar)
}